import DragOutlined from '@ant-design/icons/DragOutlined';
import React from 'react';
import { styled } from 'styled-components';

const DragHandleContainer = styled.div`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  color: #4a5568;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 3px;
  border: 1px solid #718096;
  opacity: 0.9;
  transition: all ${({ theme }) => theme.motionDurationFast} ease;
  z-index: 100;
  pointer-events: auto;

  &:hover {
    opacity: 1;
    color: #2d3748;
    border-color: #3182ce;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transform: scale(1.05);
  }

  &:active {
    cursor: grabbing;
    transform: scale(0.98);
  }

  .anticon {
    font-size: 10px;
    pointer-events: none;
  }
`;

export interface DragHandleProps {
  className?: string;
}

export const DragHandle: React.FC<DragHandleProps> = ({ className = '' }) => {
  return (
    <DragHandleContainer
      className={`drag-handle ${className}`}
      data-testid="drag-handle"
      title="Drag to move block"
    >
      <DragOutlined />
    </DragHandleContainer>
  );
};
